<div class="dashboard-heading">
  <h1>Dashboard</h1>
  <div>
    <dx-button text="{{ 'SYNC' | translate }}" icon="mdi mdi-sync" class="btn btn-green" (onClick)="this.sync()"></dx-button>
  </div>
</div>
<div class="mb-5">
  <h2 class="m-0 font-weight-normal">{{ 'HEAD' | translate }}</h2>
  <div class="row mb-2">
    <div class="col-md-12">
      <p class="font-size-16 color-gray mb-2">{{ 'HELLO' | translate }}</p>
      <div class="position-relative">
        <dx-tab-panel
          [dataSource]="pages"
          [selectedIndex]="0"
          [loop]="true"
          [animationEnabled]="true"
          [swipeEnabled]="false"
          [showNavButtons]="false"
          [scrollByContent]="true"
          [scrollingEnabled]="true"
          class="dx-tab-panel-bottom">
          <div *dxTemplate="let page of 'title'">
            <span>{{ page.caption | translate }}</span>
          </div>
          <div *dxTemplate="let page of 'item'" class="dx-tab-panel-block">
            <!-- <dx-scroll-view  direction="both" showScrollbar="OnHover" useNative="false" scrollByThumb="true"> -->
            @if (page.id === 2) {
              <div class="h-100">
                <dx-text-area [(value)]="this.entity.headUa" class="w-100"></dx-text-area>
              </div>
            }
            @if (page.id === 1) {
              <div class="h-100">
                <dx-text-area [(value)]="this.entity.headRu" class="w-100"></dx-text-area>
              </div>
            }
            <!-- </dx-scroll-view> -->
          </div>
        </dx-tab-panel>
        <div class="d-flex align-items-center color-box-text border-left ps-3 pe-3">
          <label class="font-size-15 color-gray">Цвет</label>
          <dx-color-box class="ms-2" [(value)]="this.entity.headColor" applyValueMode="instantly" [openOnFieldClick]="true"></dx-color-box>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <p class="font-size-16 color-gray mb-2">{{ 'TEXTING' | translate }}</p>
      <div class="position-relative">
        <dx-tab-panel
          [dataSource]="pages"
          [selectedIndex]="0"
          [loop]="true"
          [animationEnabled]="true"
          [swipeEnabled]="false"
          [showNavButtons]="false"
          [scrollByContent]="true"
          [scrollingEnabled]="true"
          class="dx-tab-panel-bottom">
          <div *dxTemplate="let page of 'title'">
            <span>{{ page.caption | translate }}</span>
          </div>
          <div *dxTemplate="let page of 'item'" class="dx-tab-panel-block">
            <!-- <dx-scroll-view  direction="both" showScrollbar="OnHover" useNative="false" scrollByThumb="true"> -->
            @if (page.id === 2) {
              <div class="h-100">
                <dx-text-area [(value)]="this.entity.bodyUa" class="w-100"></dx-text-area>
              </div>
            }
            @if (page.id === 1) {
              <div class="h-100">
                <dx-text-area [(value)]="this.entity.bodyRu" class="w-100"></dx-text-area>
              </div>
            }
            <!-- </dx-scroll-view> -->
          </div>
        </dx-tab-panel>
        <div class="d-flex align-items-center color-box-text border-left ps-3 pe-3">
          <label class="font-size-15 color-gray">Цвет</label>
          <dx-color-box class="ms-2" [(value)]="this.entity.bodyColor" applyValueMode="instantly" [openOnFieldClick]="true"></dx-color-box>
        </div>
      </div>
    </div>
    <div class="col-md-24 pt-3">
      <dx-button class="btn me-2" icon="mdi mdi-content-save" text="{{ 'SAVE' | translate }}" (onClick)="this.save()"></dx-button>
    </div>
  </div>
</div>
<div class="mb-5">
  <div class="">
    <h2 class="font-weight-normal">Фон</h2>
    <div class="text-start">
      <div class="rounded border p-2 d-inline-flex mb-3 align-items-center justify-content-left text-start">
        @if (this.entity.imageBody) {
          <img
            style="max-width: 100%; max-height: 300px"
            class=""
            [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + this.entity.imageType + ';base64,' + this.entity.imageBody)" />
        }
        @if (!this.entity.imageBody) {
          <img style="max-width: 100%" class="" src="/assets/images/nophoto.png" />
        }
      </div>
      <div class="ps-2">
        <div class="mb-2">
          <dx-button
            icon="mdi mdi-upload"
            class="btn me-2"
            (onClick)="this.uploadImage()"
            text="{{ 'UPLOAD_ICON' | translate }}"></dx-button>
          <dx-button class="btn btn-light" (onClick)="this.deleteImage()" text="{{ 'DELETE_ICON' | translate }}"></dx-button>
        </div>
        <div class="information p-3 py-2 font-size-13 line-height-base d-inline-flex">
          <div class="me-2">
            <i class="mdi mdi-information mdi-24px"></i>
          </div>
          <div class="">
            <div class="mb-1">Рекомендуемый размер 1920х300px</div>
            <div>Допускаются форматы JPG, PNG. Максимальный размер 800 КБ</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<dx-data-grid
  [dataSource]="this.topServices"
  [showBorders]="true"
  [columnMinWidth]="70"
  [columnAutoWidth]="true"
  class="datagrid-admin mb-5">
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column
    dataField="rank"
    sortOrder="desc"
    caption="{{ 'PRIORITY' | translate }}"
    [width]="120"
    cssClass="text-center border-right"></dxi-column>
  <dxi-column
    name="changePriority"
    type="buttons"
    caption="{{ 'CHANGE_PRIORITY' | translate }}"
    cssClass="cell-center border-right"
    [width]="160">
    <dxi-button template="changePriorityTemplate">
      <div *dxTemplate="let $row of 'changePriorityTemplate'">
        <dx-button icon="mdi mdi-arrow-up-bold" class="btn-icon color-green" (onClick)="this.downPriorityTopService($row)"></dx-button>
        <dx-button icon="mdi mdi-arrow-down-bold" class="btn-icon color-red" (onClick)="this.upPriorityTopService($row)"></dx-button>
      </div>
    </dxi-button>
  </dxi-column>

  <dxi-column
    [dataField]="this.isLanguageUa ? 'service.nameUa' : 'service.nameRu'"
    caption="{{ 'SERVICES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'service.category.nameUa' : 'service.category.nameRu'"
    caption="{{ 'SERVICES_CATEGORIES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>

  <dxi-column name="delete" type="buttons" caption="{{ 'ICON_DELETE' | translate }}">
    <dxi-button template="deleteTemplate">
      <div *dxTemplate="let $row of 'deleteTemplate'">
        <dx-button icon="mdi mdi-close-circle" class="btn-icon color-red" (onClick)="this.deleteTopService($row)"></dx-button>
      </div>
    </dxi-button>
  </dxi-column>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>
<admin-dashboard-top-service-create (onSave)="this.saveTopService($event)"></admin-dashboard-top-service-create>
<dialog-edit-image></dialog-edit-image>
